module.exports = __webpack_public_path__ + "static/media/bq-se.3f241dbd.svg";